import { Component, OnInit } from '@angular/core';
import {HttpserviceService} from '../common/services/httpservice.service';
import {retry} from 'rxjs/operators';
import { SessionsService } from '../common/services/sessions.service';
import { Router,ActivatedRoute  } from '@angular/router';
import {ConstantsService} from '../common/services/constants.service';
declare var show_okshan_alert3: Function;

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.css']
})
export class PaymentComponent implements OnInit {

  constructor(
  private httpserviceService:HttpserviceService,
  private sessionsService:SessionsService,
  private router:Router,
  private _constant: ConstantsService,
  private route:ActivatedRoute) { }

  fileUrl;
  apiUrl;
  webUrl
  bidAmount:any=0;
  securityAmount:any=0;
  data:any='';  

  ngOnInit(): void {
  if(this.route.snapshot.queryParamMap.get('qzwp')!=null)
  {
  this.fileUrl=this._constant.uploadFileUrl; 
  this.apiUrl=this._constant.httpServicesUrl;
  this.webUrl=this._constant.webUrl;   
  this.data=atob(this.route.snapshot.queryParamMap.get('qzwp'));   
  this.handleData(JSON.parse(this.data))  
  }   
  }

  handleData(data)
  {
        if(data.ev)
      {
        if(data.ev=="bid")
        {
        this.saveBidDetail(data)
        }
        else if(data.ev=="jk")//join okshan
        {
        this.saveJoinOkshanDetail(data)
        }
        else if(data.ev=="bn")//buy now
        {
        this.saveBuyNowPayment(data)
        }
        else if(data.ev=="of")//make an offer amount
        {
        this.saveMakeAnOfferPayment(data)
        }
        else if(data.ev=="tp")//topup
        {
        //alert(this.apiUrl+"RechargeMyWallet?profile_id="+this.sessionsService.getSession('id')+"&amount="+data.amount+"&order_note=Wallet Recharge&return_url="+btoa(this.webUrl+"my-payment-history"))  
        let detail={"type":"Wallet Recharge","profile_id":this.sessionsService.getSession('id'),"amount":data.amount,"order_note":data.remark,"return_url":btoa(this.webUrl+"my-payment-history")}
        //console.log(btoa(JSON.stringify(detail)))
        window.location.href=this.apiUrl+"RechargeMyWallet?sdgvc="+btoa(JSON.stringify(detail));
        }
      }
  }

  /** saveBidDetail function used to save bid detail */
  saveBidDetail(data)
  {
     let body={profile_id: this.sessionsService.getSession('id'), car_id:data.car_id , bid_amount:data.amt, reserve_amount:data.sec}
     let result =this.httpserviceService.saveBidDetailRequest(body).
     pipe(retry(0)).
     subscribe((data)=>this.saveBidDetailResponse(data), 
     err => {
       show_okshan_alert3("Something went wrong !");
       console.log('Something went wrong ', err);       
    })       
  //}
  }

  

  /** saveBidDetailResponse method used to handle response */
  saveBidDetailResponse(response)
  {
    console.log('saveDocumentDetailResponse '+ response.status);
    if(response.status==="success")  
     {
       show_okshan_alert3("Detail is saved");       
     }
     else
     {
     show_okshan_alert3(response.reason);     
     } 
  }

  /** saveJoinOkshanDetail function used to save join okshan  detail */
  saveJoinOkshanDetail(data)
  {
     let body={profile_id: this.sessionsService.getSession('id'), car_id:data.car_id, security_amount:data.sec}
     let result =this.httpserviceService.saveJoinOkshanDetailRequest(body).
     pipe(retry(0)).
     subscribe((data)=>this.saveJoinOkshanDetailResponse(data), 
     err => {
       show_okshan_alert3("Something went wrong !");
       console.log('Something went wrong ', err);       
    })       
  //}
  }

  

  /** saveJoinOkshanDetailResponse method used to handle response */
  saveJoinOkshanDetailResponse(response)
  {
    console.log('saveJoinOkshanDetailResponse '+ response.status);
    if(response.status==="success")  
     {
       show_okshan_alert3("Detail is saved");       
     }
     else
     {
     show_okshan_alert3(response.reason);     
     } 
  }

  /** saveBuyNowPayment function used to save buy now payment */
  saveBuyNowPayment(data)
  {
     let body={profile_id: this.sessionsService.getSession('id'), car_id:data.car_id, security_amount:data.sec}
     let result =this.httpserviceService.saveBuyNowPaymentRequest(body).
     pipe(retry(0)).
     subscribe((data)=>this.saveBuyNowPaymentResponse(data), 
     err => {
       show_okshan_alert3("Something went wrong !");
       console.log('Something went wrong ', err);       
    })       
  //}
  }

  

  /** saveBuyNowPaymentResponse method used to handle response */
  saveBuyNowPaymentResponse(response)
  {
    console.log('saveBuyNowPaymentResponse '+ response.status);
    if(response.status==="success")  
     {
       show_okshan_alert3("Detail is saved");    
       this.router.navigate(['fixed-price-car-detail'], { queryParams: { id: response.car_id } });   
     }
     else
     {
     show_okshan_alert3(response.reason);     
     } 
  }

  /** saveMakeAnOfferPayment function used to save make an offer payment */
  saveMakeAnOfferPayment(data)
  {
     let body={profile_id: this.sessionsService.getSession('id'), car_id:data.car_id, amount:data.amt}
     let result =this.httpserviceService.saveMakeAnOfferPaymentRequest(body).
     pipe(retry(0)).
     subscribe((data)=>this.saveMakeAnOfferPaymentResponse(data), 
     err => {
       show_okshan_alert3("Something went wrong !");
       console.log('Something went wrong ', err);       
    })       
  //}
  }

  

  /** saveMakeAnOfferPaymentResponse method used to handle response */
  saveMakeAnOfferPaymentResponse(response)
  {
    console.log('saveMakeAnOfferPaymentResponse '+ response.status);
    if(response.status==="success")  
     {
       show_okshan_alert3("Detail is saved");       
       this.router.navigate(['fixed-price-car-detail'], { queryParams: { id: response.car_id } });
     }
     else
     {
     show_okshan_alert3(response.reason);     
     } 
  }

}
